<template>
    <g>
        <path 
            v-bind="{
                class : 'tool_svgElem',
                id : tool.id + '-body',
                d : d_path(true)
            }"
        />
    </g>
</template>

// =========================================================================================
// =========================================================================================

<script>
import { mapActions, mapState } from 'vuex';
import { tools   } from '../../mixins/tools';
import { paths   } from '../../mixins/paths';
import { gConsts } from '@/globals/gConsts';
import { utils   } from '@/globals/utils';
import { mapGetters } from 'vuex/dist/vuex.common.js';
import { evtBus  } from '@/main';

// =========================================================================================

export default {
    name : 'retangIncCMP',

    mixins: [tools, paths],

    data () {
        return {
        }
    },

    computed: {
        ...mapState({
        }),

        ...mapGetters([
        ])
    },

    methods: {
        ...mapActions([
            'ACT_toolUpdate',
            'ACT_toolAddPts'
        ]),

        mouseMove(evt, pM, moveType, toolPt) {
            var isEdit, isCreationPt2,
                vADLen, 
                pA, pB, pC, pD,
                vAB, vPerp_vAB, vBC,
                // tool, toolPt,
                totalToolPtsReached = false,
                pts = null,
                handled = false;


            // tool   = this.GET_movTool;
            // toolPt = this.GET_movTool.Pt;

            isEdit        = moveType == gConsts.mov.types.HANDLE_DRAG;
            isCreationPt2 = (moveType == gConsts.mov.types.TOOL_CREATION) && (toolPt == 2);
            if (isEdit || isCreationPt2) {
                pA = this.$Victor.fromObject(this.tool.coords.pts[0]);
                pB = this.$Victor.fromObject(this.tool.coords.pts[1]);

                // Calc pC e pD baseado na projecao de vBM em vPerp_vAB
                if ([2, 3].includes(toolPt)) {
                    totalToolPtsReached = (utils.numToolPts == this.tool.coords.pts.length)
                    if ((moveType == gConsts.mov.types.TOOL_CREATION) && (!totalToolPtsReached)) {
                        evtBus.$emit('evt_toolAction', 'addPts', { tool_pt: toolPt });
                        // this.ACT_toolAddPts({ tool_id: this.tool.id, tool_pt: toolPt });
                    }

                    vAB       = pB.clone().subtract(pA);
                    vPerp_vAB = utils.vPerp_vAB(vAB);
                    pC        = utils.projP_vAB(pM, pB, vPerp_vAB).proj;  // acha a projM em vPerp_vAB = pC
                    vBC       = pC.clone().subtract(pB);
                    pD        = pA.clone().add(vBC);

                    pts = {
                        2 : pC.toObject(),
                        3 : pD.toObject()
                    }

                // Calc pA || pB baseado no mouseMove e pC e pD baseado no comprimento anterior de vAD 
                } else if ([0, 1].includes(toolPt)) {            
                    pD = this.$Victor.fromObject(this.tool.coords.pts[3]);
                    pC = this.$Victor.fromObject(this.tool.coords.pts[2]);

                    vADLen = pD.clone().subtract(pA).length();  // acha o tamanho do lado perp antes do move
                    switch (toolPt) {                           // atualiza pA ou pB para pM (pos do mouse)
                        case 0 : pA.copy(pM); break;
                        case 1 : pB.copy(pM); break;
                    }
                    vAB       = pB.clone().subtract(pA);
                    vPerp_vAB = new this.$Victor(-vAB.y, vAB.x).normalize().multiply(new this.$Victor(vADLen, vADLen));

                    pC = pB.clone().add(vPerp_vAB);
                    pD.copy(pA.clone().add(vPerp_vAB));

                    pts = {                        
                        2 : pC.toObject(),
                        3 : pD.toObject()
                    }      
                    switch (toolPt) {
                        case 0 : pts[0] = pA.toObject(); break;
                        case 1 : pts[1] = pB.toObject(); break;
                    }
                }

                if (pts != null) {
                    evtBus.$emit('evt_toolAction', 'updatePts', { pts : pts });
                    // this.ACT_toolUpdate({ tool_id: this.tool.id, pts : pts });
                    handled = true;
                }
            }

            return handled;
        }
    },

    // =========================================================================================
    // Lifecycle hooks

    created() {
    },

}
</script>

// =========================================================================================
// =========================================================================================

<style scoped>
</style>